import React from 'react';
import Chat from './Chat';
import {ChatSection, WorkspaceContainer} from './ChatWorkspace.styled';

import {SelectedFilesProvider} from '../../contexts/SelectedFilesContext';

const ChatWorkspace = () => {
    return (
        <SelectedFilesProvider>
            <WorkspaceContainer>
                <ChatSection $panelOpen={true}>
                    <Chat />
                </ChatSection>
            </WorkspaceContainer>
        </SelectedFilesProvider>
    );
};

export default ChatWorkspace;
